import { PlusOutlined, LoadingOutlined, EditTwoTone, EyeFilled } from "@ant-design/icons";
import { Button, Col, Row, Spin, Table } from "antd";
import React from "react";
import CTConfiguration from "../../Services/CTConfigurationService";
import { adminContext } from "../../Common/PageRoute";
import Link from "antd/es/typography/Link";
import { useUser } from "../../Context/UserContext";
import { ColumnsType } from "antd/es/table";
import AddCompanyNames from "./AddCompanyNames";
import { TableToolbar } from "../../Common/Layout";

interface CTConfigurationCompanyNames {
    id?: number;
    from: string;
    to: string;
}

const CompanyNames = () => {
    const { openNotification } = React.useContext(adminContext);
    const [companyNamesList, setCompanyNamesList] = React.useState<CTConfigurationCompanyNames[]>([]);
    const [dialog, setDialog] = React.useState<{ type: string, params: any }>({ type: "", params: {} });
    const [loading, setLoading] = React.useState(false);
    const [refresh, setRefresh] = React.useState(true);
    const { isSubAdmin } = useUser();

    const columns: ColumnsType<CTConfigurationCompanyNames> = [
        {
            title: "S.No",
            dataIndex: "sno",
            key: "sno",
            width: "7%",
            render: (_: any, record: any, index: any) => <p>{record.id + 1}</p>,
        },
        {
            title: "From",
            dataIndex: "from",
            key: "from",
            width: "30%",
        },
        {
            title: "To",
            dataIndex: "to",
            key: "to",
            width: "30%",
        },
        {
            title: "Action",
            dataIndex: "id",
            key: "Id",
            render: (_: any, record: any, index: any) => (
                <Link
                    className="edit-btn"
                    onClick={() => {
                        if (record.id !== undefined || record.id !== null) {
                            setDialog({
                                type: "addCompanyNames",
                                params: { id: record?.id, record: record },
                            });
                        } else {
                            openNotification("error", "Id not Found")
                        }
                    }}
                >
                    {isSubAdmin() ? <EyeFilled /> : <EditTwoTone />}
                </Link>
            ),
        },
    ];

    React.useEffect(() => {
        const getCompanyNamesList = async () => {
            setLoading(true);
            let res = await CTConfiguration.getCompanyNames();
            if (res.status) {
                const data = res.result.map((item: CTConfigurationCompanyNames, index: number) => ({
                    ...item,
                    id: index
                }));
                setCompanyNamesList(data);
                setLoading(false);
            } else {
                setLoading(false);
            }
        };
        getCompanyNamesList();
    }, [refresh])

    const primaryActions: any[] = [];
    if (!isSubAdmin()) {
        primaryActions.push({
            label: "Company Name",
            icon: <PlusOutlined />,
            type: "primary",
            onClick: () => setDialog({ type: "addCompanyNames", params: {} }),
        });
    }
    return (
        <div>
            <div>
                <TableToolbar
                    primaryActions={primaryActions}
                />
            </div>
            <Table
                dataSource={companyNamesList.length > 0 ? companyNamesList : []}
                columns={columns}
                size="small"
                // className="aoa-custom-table border-top-table"
                className="border-top-table"
                loading={{ spinning: loading, indicator: <Spin indicator={<LoadingOutlined />} /> }}
                locale={{
                    triggerDesc: "",
                    triggerAsc: "",
                    cancelSort: "",
                }}
                pagination={{
                    defaultPageSize: 15,
                    showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`,
                    showSizeChanger: true,
                    total: companyNamesList?.length,
                    pageSizeOptions: ["15", "25", "50", "100"],
                }}
                scroll={{ x: 1024 }}
            />
            {dialog.type === "addCompanyNames" && (
                <AddCompanyNames
                    isViewOnly={isSubAdmin()}
                    id={dialog.params?.id}
                    record={dialog.params?.record}
                    onDismiss={(confirmed: any) => {
                        setDialog({ type: "", params: {} });
                        if (confirmed) {
                            setRefresh((x) => x = !x);
                        }
                    }}
                />
            )}
        </div>
    );
};

export default CompanyNames;